export const AllModels = {
    "Instagram" : [
    {
      "name": "User",
      "properties": [
        {
          "name": "username",
          "type": "String",
          "required": true,
          "unique": true,
          "minLength": 3,
          "maxLength": 30,
          "match": "^[a-zA-Z0-9_]+$"
        },
        {
          "name": "email",
          "type": "String",
          "required": true,
          "unique": true
        },
        {
          "name": "password",
          "type": "String",
          "required": true
        },
        {
          "name": "firstName",
          "type": "String"
        },
        {
          "name": "lastName",
          "type": "String"
        },
        {
          "name": "displayName",
          "type": "String"
        },
        {
          "name": "biography",
          "type": "String",
          "maxLength": 500
        },
        {
          "name": "profilePictureUrl",
          "type": "File"
        },
        {
          "name": "coverPhotoUrl",
          "type": "File"
        },
        {
          "name": "dateOfBirth",
          "type": "Date"
        },
        {
          "name": "location",
          "type": "String"
        },
        {
          "name": "websiteURL",
          "type": "String"
        },
        {
          "name": "phoneNumber",
          "type": "String"
        },
        {
          "name": "isVerified",
          "type": "Boolean",
          "default": false
        },
        {
          "name": "isPublic",
          "type": "Boolean",
          "default": true
        },
        {
          "name": "isActive",
          "type": "Boolean",
          "default": true
        },
        {
          "name": "isBanned",
          "type": "Boolean",
          "default": false
        },
        {
          "name": "lastActivity",
          "type": "Date"
        }
      ],
      "options": {
        "timestamps": true
      }
    },
    {
      "name": "UserSettings",
      "properties": [
        {
          "name": "emailNotifications",
          "type": "Boolean",
          "default": true
        },
        {
          "name": "pushNotifications",
          "type": "Boolean",
          "default": true
        },
        {
          "name": "smsNotifications",
          "type": "Boolean",
          "default": false
        },
        {
          "name": "postVisibility",
          "type": "String",
          "enum": [
            "public",
            "friends",
            "private"
          ],
          "default": "public"
        },
        {
          "name": "profileVisibility",
          "type": "String",
          "enum": [
            "public",
            "friends",
            "private"
          ],
          "default": "public"
        },
        {
          "name": "followerListVisibility",
          "type": "String",
          "enum": [
            "public",
            "friends",
            "private"
          ],
          "default": "public"
        },
        {
          "name": "allowTagging",
          "type": "Boolean",
          "default": true
        },
        {
          "name": "allowMentions",
          "type": "Boolean",
          "default": true
        },
        {
          "name": "twoFactorAuthEnabled",
          "type": "Boolean",
          "default": false
        },
        {
          "name": "languagePreference",
          "type": "String",
          "default": "en"
        },
        {
          "name": "timezone",
          "type": "String",
          "default": "UTC"
        },
        {
          "name": "uiTheme",
          "type": "String",
          "enum": [
            "light",
            "dark",
            "auto"
          ],
          "default": "auto"
        }
      ],
      "options": {
        "timestamps": false
      }
    },
    {
      "name": "Post",
      "properties": [
        {
          "name": "content",
          "type": "String",
          "maxLength": 5000
        },
        {
          "name": "contentType",
          "type": "String",
          "enum": [
            "text",
            "image",
            "video",
            "link"
          ],
          "default": "text"
        },
        {
          "name": "visibility",
          "type": "String",
          "enum": [
            "public",
            "friends",
            "private"
          ],
          "default": "public"
        },
        {
          "name": "isEdited",
          "type": "Boolean",
          "default": false
        },
        {
          "name": "isPinned",
          "type": "Boolean",
          "default": false
        },
        {
          "name": "locationTag",
          "type": "String"
        },
        {
          "name": "hashtags",
          "type": "String",
          "isArray": true
        },
        {
          "name": "userMentions",
          "type": "Reference",
          "isArray": true,
          "reference": "User"
        },
        {
          "name": "likesCount",
          "type": "Number",
          "default": 0,
          "min": 0
        },
        {
          "name": "commentsCount",
          "type": "Number",
          "default": 0,
          "min": 0
        },
        {
          "name": "repostsCount",
          "type": "Number",
          "default": 0,
          "min": 0
        },
        {
          "name": "viewsCount",
          "type": "Number",
          "default": 0,
          "min": 0
        },
         {
          "name": "userId",
          "type": "Reference",
          "reference": "User",
          "required": true
        }
      ],
      "options": {
        "timestamps": true
      }
    },
    {
      "name": "Media",
      "properties": [
        {
          "name": "fileURL",
          "type": "File",
          "required": true
        },
        {
          "name": "thumbnailURL",
          "type": "File"
        },
        {
          "name": "fileSize",
          "type": "Number",
          "min": 0
        },
        {
          "name": "dimensions",
          "type": "String"
        },
        {
          "name": "duration",
          "type": "Number"
        },
        {
          "name": "altText",
          "type": "String",
          "maxLength": 200
        },
        {
          "name": "order",
          "type": "Number"
        },
        {
            "name": "postId",
            "type": "Reference",
            "reference": "Post",
            "required": true
        }
      ],
      "options": {
        "timestamps": true
      }
    },
    {
      "name": "Comment",
      "properties": [
        {
          "name": "content",
          "type": "String",
          "maxLength": 1000,
          "required": true
        },
        {
          "name": "userMentions",
          "type": "Reference",
          "isArray": true,
          "reference": "User"
        },
        {
          "name": "isEdited",
          "type": "Boolean",
          "default": false
        },
        {
          "name": "likesCount",
          "type": "Number",
          "default": 0,
          "min": 0
        },
        {
          "name": "repliesCount",
          "type": "Number",
          "default": 0,
          "min": 0
        },
        {
            "name": "postId",
            "type": "Reference",
            "reference": "Post",
            "required": true
        },
        {
           "name": "userId",
            "type": "Reference",
            "reference": "User",
            "required": true
        },
        {
          "name": "parentCommentId",
          "type": "Reference",
          "reference": "Comment"
        }
      ],
      "options": {
        "timestamps": true
      }
    },
    {
      "name": "Follow",
      "properties": [
        {
          "name": "followerId",
          "type": "Reference",
          "reference": "User",
          "required": true
        },
        {
          "name": "followingId",
          "type": "Reference",
          "reference": "User",
          "required": true
        },
        {
          "name": "status",
          "type": "String",
          "enum": [
            "pending",
            "accepted",
            "blocked"
          ],
          "default": "accepted"
        }
      ],
      "options": {
        "timestamps": true
      }
    },
    {
      "name": "Like",
      "properties": [
        {
          "name": "userId",
          "type": "Reference",
          "reference": "User",
          "required": true
        },
        {
          "name": "likeableType",
          "type": "String",
          "enum": [
            "Post",
            "Comment"
          ],
          "required": true
        },
        {
          "name": "likeableId",
          "type": "Reference",
          "required": true
        }
      ],
      "options": {
        "timestamps": true
      }
    },
    {
      "name": "Block",
      "properties": [
        {
          "name": "blockerId",
          "type": "Reference",
          "reference": "User",
          "required": true
        },
        {
          "name": "blockedId",
          "type": "Reference",
          "reference": "User",
          "required": true
        },
        {
          "name": "reason",
          "type": "String",
          "maxLength": 200
        }
      ],
      "options": {
        "timestamps": true
      }
    },
    {
      "name": "Conversation",
      "properties": [
        {
          "name": "conversationType",
          "type": "String",
          "enum": [
            "direct",
            "group"
          ],
          "default": "direct"
        },
        {
          "name": "title",
          "type": "String"
        },
        {
          "name": "description",
          "type": "String"
        },
        {
          "name": "creatorId",
          "type": "Reference",
          "reference": "User"
        },
        {
          "name": "isActive",
          "type": "Boolean",
          "default": true
        },
        {
            "name": "lastMessageTimestamp",
            "type": "Date"
        }
      ],
      "options": {
        "timestamps": true
      }
    },
    {
      "name": "ConversationParticipant",
      "properties": [
        {
          "name": "userId",
          "type": "Reference",
          "reference": "User",
          "required": true
        },
        {
          "name": "conversationId",
          "type": "Reference",
          "reference": "Conversation",
          "required": true
        },
        {
          "name": "role",
          "type": "String",
          "enum": [
            "member",
            "admin"
          ],
          "default": "member"
        },
        {
          "name": "muteStatus",
          "type": "Boolean",
          "default": false
        },
        {
            "name":"lastReadTimestamp",
            "type":"Date",
            "required":false
        }
      ],
      "options": {
        "timestamps": true
      }
    },
    {
      "name": "Message",
      "properties": [
        {
          "name": "senderId",
          "type": "Reference",
          "reference": "User",
          "required": true
        },
        {
          "name": "conversationId",
          "type": "Reference",
          "reference": "Conversation",
          "required": true
        },
        {
          "name": "messageType",
          "type": "String",
          "enum": [
            "text",
            "image",
            "video",
            "file",
            "system"
          ],
          "default": "text"
        },
        {
          "name": "content",
          "type": "String",
          "maxLength": 2000
        },
        {
          "name": "isEdited",
          "type": "Boolean",
          "default": false
        },
        {
          "name": "isDeleted",
          "type": "Boolean",
          "default": false
        },
        {
          "name": "replyToMessageId",
          "type": "Reference",
          "reference": "Message"
        }
      ],
      "options": {
        "timestamps": true
      }
    },
    {
      "name": "MessageMedia",
      "properties": [
        {
          "name": "messageId",
          "type": "Reference",
          "reference": "Message",
          "required": true
        },
        {
          "name": "fileURL",
          "type": "File",
          "required": true
        },
        {
          "name": "originalFilename",
          "type": "String"
        },
        {
          "name": "fileSize",
          "type": "Number",
          "min": 0
        },
        {
          "name": "mimeType",
          "type": "String"
        }
      ],
      "options": {
        "timestamps": true
      }
    },
    {
      "name": "Hashtag",
      "properties": [
        {
          "name": "name",
          "type": "String",
          "required": true,
          "unique": true,
          "minLength": 1,
          "maxLength": 50
        },
        {
          "name": "displayName",
          "type": "String"
        },
        {
          "name": "description",
          "type": "String"
        },
        {
          "name": "postsCount",
          "type": "Number",
          "default": 0,
          "min": 0
        },
        {
          "name": "followersCount",
          "type": "Number",
          "default": 0,
          "min": 0
        },
        {
          "name": "isTrending",
          "type": "Boolean",
          "default": false
        }
      ],
      "options": {
        "timestamps": true
      }
    },
    {
      "name": "HashtagFollow",
      "properties": [
        {
          "name": "userId",
          "type": "Reference",
          "reference": "User",
          "required": true
        },
        {
          "name": "hashtagId",
          "type": "Reference",
          "reference": "Hashtag",
          "required": true
        }
      ],
      "options": {
        "timestamps": true
      }
    },
    {
      "name": "Trending",
      "properties": [
        {
          "name": "trendableType",
          "type": "String",
          "enum": [
            "Hashtag",
            "User",
            "Post"
          ],
          "required": true
        },
        {
          "name": "trendableId",
          "type": "Reference",
          "required": true,
          "reference": "User"
        },
        {
          "name": "trendingScore",
          "type": "Number",
          "default": 0
        },
        {
          "name": "expirationTimestamp",
          "type": "Date"
        }
      ],
      "options": {
        "timestamps": true
      }
    },
    {
      "name": "Notification",
      "properties": [
        {
          "name": "recipientId",
          "type": "Reference",
          "reference": "User",
          "required": true
        },
        {
          "name": "type",
          "type": "String",
          "enum": [
            "like",
            "comment",
            "follow",
            "mention",
            "message"
          ],
          "required": true
        },
        {
          "name": "title",
          "type": "String"
        },
        {
          "name": "messageContent",
          "type": "String"
        },
        {
          "name": "data",
          "type": "String"
        },
        {
          "name": "actorId",
          "type": "Reference",
          "reference": "User"
        },
        {
          "name": "relatedEntityType",
          "type": "String"
        },
        {
          "name": "relatedEntityId",
          "type": "Reference"
        },
        {
          "name": "isRead",
          "type": "Boolean",
          "default": false
        },
        {
          "name": "isSent",
          "type": "Boolean",
          "default": false
        },
        {
          "name": "priority",
          "type": "String",
          "enum": [
            "high",
            "medium",
            "low"
          ],
          "default": "medium"
        }
      ],
      "options": {
        "timestamps": true
      }
    },
    {
      "name": "Report",
      "properties": [
        {
          "name": "reporterId",
          "type": "Reference",
          "reference": "User",
          "required": true
        },
        {
          "name": "reportableType",
          "type": "String",
          "enum": [
            "User",
            "Post",
            "Comment",
            "Message"
          ],
          "required": true
        },
        {
          "name": "reportableId",
          "type": "Reference",
          "required": true
        },
        {
          "name": "reason",
          "type": "String",
          "enum": [
            "spam",
            "harassment",
            "inappropriate",
            "copyright",
            "other"
          ],
          "required": true
        },
        {
          "name": "status",
          "type": "String",
          "enum": [
            "pending",
            "reviewing",
            "resolved",
            "dismissed"
          ],
          "default": "pending"
        },
        {
          "name": "reviewingAdminId",
          "type": "Reference",
          "reference": "User"
        },
        {
          "name": "resolutionDetails",
          "type": "String"
        }
      ],
      "options": {
        "timestamps": true
      }
    },
    {
      "name": "AdminAction",
      "properties": [
        {
          "name": "adminId",
          "type": "Reference",
          "reference": "User",
          "required": true
        },
        {
          "name": "actionType",
          "type": "String",
          "enum": [
            "ban",
            "unban",
            "delete",
            "warn",
            "verify"
          ],
          "required": true
        },
        {
          "name": "targetType",
          "type": "String",
          "enum": [
            "User",
            "Post",
            "Comment",
            "Message"
          ],
          "required": true
        },
        {
          "name": "targetId",
          "type": "Reference",
          "required": true
        },
        {
          "name": "reason",
          "type": "String"
        },
        {
          "name": "duration",
          "type": "Number"
        },
        {
          "name": "metadata",
          "type": "String"
        }
      ],
      "options": {
        "timestamps": true
      }
    },
    {
      "name": "UserActivity",
      "properties": [
        {
          "name": "userId",
          "type": "Reference",
          "reference": "User",
          "required": true
        },
        {
          "name": "activityType",
          "type": "String",
          "enum": [
            "login",
            "logout",
            "postCreation",
            "engagementActions"
          ],
          "required": true
        },
        {
          "name": "ipAddress",
          "type": "String"
        },
        {
          "name": "userAgent",
          "type": "String"
        },
        {
          "name": "platform",
          "type": "String"
        }
      ],
      "options": {
        "timestamps": true
      }
    },
    {
      "name": "PostAnalytics",
      "properties": [
        {
          "name": "postId",
          "type": "Reference",
          "reference": "Post",
          "required": true
        },
        {
          "name": "date",
          "type": "Date",
          "required": true
        },
        {
          "name": "views",
          "type": "Number",
          "default": 0,
          "min": 0
        },
        {
          "name": "likes",
          "type": "Number",
          "default": 0,
          "min": 0
        },
        {
          "name": "comments",
          "type": "Number",
          "default": 0,
          "min": 0
        },
        {
          "name": "reposts",
          "type": "Number",
          "default": 0,
          "min": 0
        },
        {
          "name": "reach",
          "type": "Number",
          "default": 0,
          "min": 0
        },
        {
            "name":"engagementRate",
            "type":"Number",
            "required":false
        }
      ],
      "options": {
        "timestamps": true
      }
    }
  ],
    "Zomato" : [
  {
    "name": "Customer",
    "properties": [
      { "name": "userId", "type": "String", "required": true, "unique": true },
      { "name": "email", "type": "String", "required": true, "unique": true },
      { "name": "phone", "type": "String", "unique": true },
      { "name": "defaultAddress", "type": "String" },
      { "name": "loyaltyPoints", "type": "Number", "default": 0, "min": 0 }
    ],
    "options": { "timestamps": true }
  },
  {
    "name": "Restaurant",
    "properties": [
      { "name": "name", "type": "String", "required": true },
      { "name": "cuisine", "type": "String", "isArray": true },
      { "name": "address", "type": "String", "required": true },
      { "name": "rating", "type": "Number", "min": 0, "max": 5, "default": 0 },
      { "name": "deliveryTimeEstimateMin", "type": "Number" },
      { "name": "isAcceptingOrders", "type": "Boolean", "default": true }
    ],
    "options": { "timestamps": true }
  },
  {
    "name": "MenuItem",
    "properties": [
      { "name": "restaurantId", "type": "Reference", "reference": "Restaurant", "required": true },
      { "name": "name", "type": "String", "required": true },
      { "name": "description", "type": "String", "maxLength": 500 },
      { "name": "price", "type": "Number", "required": true, "min": 0.01 },
      { "name": "category", "type": "String", "enum": ["appetizer", "main", "dessert", "drink"] },
      { "name": "isVegetarian", "type": "Boolean", "default": false }
    ],
    "options": { "timestamps": true }
  },
  {
    "name": "Order",
    "properties": [
      { "name": "customerId", "type": "Reference", "reference": "Customer", "required": true },
      { "name": "restaurantId", "type": "Reference", "reference": "Restaurant", "required": true },
      { "name": "deliveryAddress", "type": "String", "required": true },
      { "name": "totalAmount", "type": "Number", "required": true, "min": 0 },
      { "name": "status", "type": "String", "enum": ["pending", "confirmed", "preparing", "ready", "pickedUp", "delivered", "canceled"], "default": "pending" },
      { "name": "estimatedDeliveryTime", "type": "Date" }
    ],
    "options": { "timestamps": true }
  },
  {
    "name": "OrderLineItem",
    "properties": [
      { "name": "orderId", "type": "Reference", "reference": "Order", "required": true },
      { "name": "menuItemId", "type": "Reference", "reference": "MenuItem", "required": true },
      { "name": "quantity", "type": "Number", "required": true, "min": 1 },
      { "name": "notes", "type": "String" }
    ],
    "options": { "timestamps": false }
  },
  {
    "name": "DeliveryPartner",
    "properties": [
      { "name": "name", "type": "String", "required": true },
      { "name": "vehicleType", "type": "String", "enum": ["bike", "scooter", "car", "bicycle"] },
      { "name": "currentLocation", "type": "String" },
      { "name": "isAvailable", "type": "Boolean", "default": true },
      { "name": "rating", "type": "Number", "min": 0, "max": 5, "default": 5 }
    ],
    "options": { "timestamps": true }
  },
  {
    "name": "DeliveryAssignment",
    "properties": [
      { "name": "orderId", "type": "Reference", "reference": "Order", "required": true, "unique": true },
      { "name": "partnerId", "type": "Reference", "reference": "DeliveryPartner", "required": true },
      { "name": "pickupTime", "type": "Date" },
      { "name": "dropoffTime", "type": "Date" }
    ],
    "options": { "timestamps": true }
  }
],
    "Airport Management" : [
  {
    "name": "Airport",
    "properties": [
      {
        "name": "iataCode",
        "type": "String",
        "required": true,
        "unique": true,
        "minLength": 3,
        "maxLength": 3,
        "match": "^[A-Z]{3}$"
      },
      {
        "name": "name",
        "type": "String",
        "required": true
      },
      {
        "name": "city",
        "type": "String"
      },
      {
        "name": "country",
        "type": "String"
      },
      {
        "name": "timezone",
        "type": "String",
        "default": "UTC"
      }
    ],
    "options": {
      "timestamps": false
    }
  },
  {
    "name": "Airline",
    "properties": [
      {
        "name": "iataCode",
        "type": "String",
        "required": true,
        "unique": true,
        "minLength": 2,
        "maxLength": 2,
        "match": "^[A-Z0-9]{2}$"
      },
      {
        "name": "name",
        "type": "String",
        "required": true
      },
      {
        "name": "contactEmail",
        "type": "String"
      },
      {
        "name": "isCargo",
        "type": "Boolean",
        "default": false
      }
    ],
    "options": {
      "timestamps": true
    }
  },
  {
    "name": "Aircraft",
    "properties": [
      {
        "name": "registrationNumber",
        "type": "String",
        "required": true,
        "unique": true
      },
      {
        "name": "model",
        "type": "String",
        "required": true
      },
      {
        "name": "capacity",
        "type": "Number",
        "required": true,
        "min": 1
      },
      {
        "name": "airlineId",
        "type": "Reference",
        "reference": "Airline",
        "required": true
      },
      {
        "name": "status",
        "type": "String",
        "enum": [
          "active",
          "maintenance",
          "retired"
        ],
        "default": "active"
      }
    ],
    "options": {
      "timestamps": true
    }
  },
  {
    "name": "Terminal",
    "properties": [
      {
        "name": "airportId",
        "type": "Reference",
        "reference": "Airport",
        "required": true
      },
      {
        "name": "terminalNumber",
        "type": "String",
        "required": true
      },
      {
        "name": "name",
        "type": "String"
      },
      {
        "name": "type",
        "type": "String",
        "enum": [
          "domestic",
          "international",
          "cargo"
        ],
        "default": "domestic"
      }
    ],
    "options": {
      "timestamps": false
    }
  },
  {
    "name": "Gate",
    "properties": [
      {
        "name": "terminalId",
        "type": "Reference",
        "reference": "Terminal",
        "required": true
      },
      {
        "name": "gateNumber",
        "type": "String",
        "required": true
      },
      {
        "name": "isJetBridge",
        "type": "Boolean",
        "default": true
      },
      {
        "name": "status",
        "type": "String",
        "enum": [
          "available",
          "occupied",
          "maintenance"
        ],
        "default": "available"
      }
    ],
    "options": {
      "timestamps": false
    }
  },
  {
    "name": "Flight",
    "properties": [
      {
        "name": "flightNumber",
        "type": "String",
        "required": true
      },
      {
        "name": "airlineId",
        "type": "Reference",
        "reference": "Airline",
        "required": true
      },
      {
        "name": "aircraftId",
        "type": "Reference",
        "reference": "Aircraft",
        "required": true
      },
      {
        "name": "departureAirportId",
        "type": "Reference",
        "reference": "Airport",
        "required": true
      },
      {
        "name": "arrivalAirportId",
        "type": "Reference",
        "reference": "Airport",
        "required": true
      },
      {
        "name": "scheduledDeparture",
        "type": "Date",
        "required": true
      },
      {
        "name": "scheduledArrival",
        "type": "Date",
        "required": true
      },
      {
        "name": "actualDeparture",
        "type": "Date"
      },
      {
        "name": "actualArrival",
        "type": "Date"
      },
      {
        "name": "status",
        "type": "String",
        "enum": [
          "scheduled",
          "departed",
          "arrived",
          "delayed",
          "canceled",
          "boarding"
        ],
        "default": "scheduled"
      },
      {
        "name": "departureGateId",
        "type": "Reference",
        "reference": "Gate"
      },
      {
        "name": "arrivalGateId",
        "type": "Reference",
        "reference": "Gate"
      }
    ],
    "options": {
      "timestamps": true
    }
  },
  {
    "name": "Passenger",
    "properties": [
      {
        "name": "passportNumber",
        "type": "String",
        "unique": true
      },
      {
        "name": "firstName",
        "type": "String",
        "required": true
      },
      {
        "name": "lastName",
        "type": "String",
        "required": true
      },
      {
        "name": "email",
        "type": "String",
        "unique": true
      },
      {
        "name": "nationality",
        "type": "String"
      }
    ],
    "options": {
      "timestamps": true
    }
  },
  {
    "name": "Booking",
    "properties": [
      {
        "name": "bookingReference",
        "type": "String",
        "required": true,
        "unique": true
      },
      {
        "name": "flightId",
        "type": "Reference",
        "reference": "Flight",
        "required": true
      },
      {
        "name": "passengerId",
        "type": "Reference",
        "reference": "Passenger",
        "required": true
      },
      {
        "name": "seatNumber",
        "type": "String"
      },
      {
        "name": "class",
        "type": "String",
        "enum": [
          "economy",
          "business",
          "first"
        ],
        "default": "economy"
      },
      {
        "name": "status",
        "type": "String",
        "enum": [
          "confirmed",
          "checkedIn",
          "canceled",
          "boarded"
        ],
        "default": "confirmed"
      }
    ],
    "options": {
      "timestamps": true
    }
  },
  {
    "name": "Staff",
    "properties": [
      {
        "name": "employeeId",
        "type": "String",
        "required": true,
        "unique": true
      },
      {
        "name": "firstName",
        "type": "String",
        "required": true
      },
      {
        "name": "lastName",
        "type": "String",
        "required": true
      },
      {
        "name": "role",
        "type": "String",
        "enum": [
          "pilot",
          "cabinCrew",
          "groundCrew",
          "airTrafficController",
          "maintenanceTech",
          "security"
        ],
        "required": true
      },
      {
        "name": "homeAirportId",
        "type": "Reference",
        "reference": "Airport"
      }
    ],
    "options": {
      "timestamps": true
    }
  },
  {
    "name": "MaintenanceLog",
    "properties": [
      {
        "name": "aircraftId",
        "type": "Reference",
        "reference": "Aircraft",
        "required": true
      },
      {
        "name": "issueDescription",
        "type": "String",
        "maxLength": 1000,
        "required": true
      },
      {
        "name": "maintenanceType",
        "type": "String",
        "enum": [
          "routine",
          "repair",
          "inspection",
          "overhaul"
        ],
        "required": true
      },
      {
        "name": "dateStarted",
        "type": "Date",
        "required": true
      },
      {
        "name": "dateCompleted",
        "type": "Date"
      },
      {
        "name": "technicianId",
        "type": "Reference",
        "reference": "Staff"
      },
      {
        "name": "status",
        "type": "String",
        "enum": [
          "pending",
          "inProgress",
          "completed"
        ],
        "default": "pending"
      }
    ],
    "options": {
      "timestamps": true
    }
  }
],
    "Uber" : [
  {
    "name": "User",
    "properties": [
      { "name": "userId", "type": "String", "required": true, "unique": true },
      { "name": "role", "type": "String", "enum": ["rider", "driver", "admin"], "required": true },
      { "name": "email", "type": "String", "required": true, "unique": true },
      { "name": "rating", "type": "Number", "min": 1, "max": 5, "default": 5 },
      { "name": "isVerified", "type": "Boolean", "default": false }
    ],
    "options": { "timestamps": true }
  },
  {
    "name": "Vehicle",
    "properties": [
      { "name": "driverId", "type": "Reference", "reference": "User", "required": true, "unique": true },
      { "name": "licensePlate", "type": "String", "required": true, "unique": true },
      { "name": "make", "type": "String", "required": true },
      { "name": "model", "type": "String", "required": true },
      { "name": "color", "type": "String" },
      { "name": "capacity", "type": "Number", "required": true, "min": 1 },
      { "name": "vehicleType", "type": "String", "enum": ["economy", "premium", "suv", "van"], "default": "economy" }
    ],
    "options": { "timestamps": true }
  },
  {
    "name": "DriverLocation",
    "properties": [
      { "name": "driverId", "type": "Reference", "reference": "User", "required": true, "unique": true },
      { "name": "latitude", "type": "Number", "required": true },
      { "name": "longitude", "type": "Number", "required": true },
      { "name": "isOnline", "type": "Boolean", "default": false },
      { "name": "isOccupied", "type": "Boolean", "default": false }
    ],
    "options": { "timestamps": true }
  },
  {
    "name": "Trip",
    "properties": [
      { "name": "riderId", "type": "Reference", "reference": "User", "required": true },
      { "name": "driverId", "type": "Reference", "reference": "User" },
      { "name": "pickupLocation", "type": "String", "required": true },
      { "name": "dropoffLocation", "type": "String", "required": true },
      { "name": "fareAmount", "type": "Number", "min": 0 },
      { "name": "distanceMiles", "type": "Number", "min": 0 },
      { "name": "status", "type": "String", "enum": ["requested", "accepted", "arrived", "started", "completed", "canceled"], "default": "requested" },
      { "name": "startTime", "type": "Date" },
      { "name": "endTime", "type": "Date" }
    ],
    "options": { "timestamps": true }
  },
  {
    "name": "Payment",
    "properties": [
      { "name": "tripId", "type": "Reference", "reference": "Trip", "required": true, "unique": true },
      { "name": "amount", "type": "Number", "required": true, "min": 0 },
      { "name": "method", "type": "String", "enum": ["card", "cash", "wallet"], "required": true },
      { "name": "status", "type": "String", "enum": ["pending", "successful", "failed"], "default": "pending" },
      { "name": "transactionId", "type": "String", "unique": true }
    ],
    "options": { "timestamps": true }
  }
],
    "Cosultant" : [
  {
    "name": "Client",
    "properties": [
      { "name": "companyName", "type": "String", "required": true, "unique": true },
      { "name": "industry", "type": "String" },
      { "name": "contactName", "type": "String" },
      { "name": "contactEmail", "type": "String", "unique": true },
      { "name": "status", "type": "String", "enum": ["prospect", "active", "archived"], "default": "prospect" }
    ],
    "options": { "timestamps": true }
  },
  {
    "name": "Consultant",
    "properties": [
      { "name": "employeeId", "type": "String", "required": true, "unique": true },
      { "name": "firstName", "type": "String", "required": true },
      { "name": "lastName", "type": "String", "required": true },
      { "name": "title", "type": "String", "enum": ["analyst", "associate", "manager", "partner"], "required": true },
      { "name": "primarySkill", "type": "String", "enum": ["strategy", "tech", "operations", "finance"] },
      { "name": "hourlyRate", "type": "Number", "min": 0 }
    ],
    "options": { "timestamps": true }
  },
  {
    "name": "Project",
    "properties": [
      { "name": "clientId", "type": "Reference", "reference": "Client", "required": true },
      { "name": "projectName", "type": "String", "required": true },
      { "name": "description", "type": "String" },
      { "name": "budget", "type": "Number", "min": 0 },
      { "name": "startDate", "type": "Date", "required": true },
      { "name": "endDateEstimate", "type": "Date" },
      { "name": "status", "type": "String", "enum": ["proposal", "active", "onHold", "completed"], "default": "proposal" },
      { "name": "projectManagerId", "type": "Reference", "reference": "Consultant" }
    ],
    "options": { "timestamps": true }
  },
  {
    "name": "ProjectAssignment",
    "properties": [
      { "name": "projectId", "type": "Reference", "reference": "Project", "required": true },
      { "name": "consultantId", "type": "Reference", "reference": "Consultant", "required": true },
      { "name": "roleOnProject", "type": "String" },
      { "name": "allocationPercentage", "type": "Number", "min": 0, "max": 100, "default": 100 }
    ],
    "options": { "timestamps": true }
  },
  {
    "name": "TimeEntry",
    "properties": [
      { "name": "consultantId", "type": "Reference", "reference": "Consultant", "required": true },
      { "name": "projectId", "type": "Reference", "reference": "Project", "required": true },
      { "name": "date", "type": "Date", "required": true },
      { "name": "hoursLogged", "type": "Number", "required": true, "min": 0.01 },
      { "name": "description", "type": "String", "maxLength": 500 },
      { "name": "isBillable", "type": "Boolean", "default": true }
    ],
    "options": { "timestamps": true }
  }
],
    "Spotiy" : [
  {
    "name": "UserAccount",
    "properties": [
      { "name": "accountId", "type": "String", "required": true, "unique": true },
      { "name": "email", "type": "String", "required": true, "unique": true },
      { "name": "subscriptionPlan", "type": "String", "enum": ["basic", "standard", "premium"], "default": "basic" },
      { "name": "isActive", "type": "Boolean", "default": true }
    ],
    "options": { "timestamps": true }
  },
  {
    "name": "Content",
    "properties": [
      { "name": "title", "type": "String", "required": true },
      { "name": "contentType", "type": "String", "enum": ["movie", "series", "album", "podcast"], "required": true },
      { "name": "genre", "type": "String", "isArray": true },
      { "name": "releaseDate", "type": "Date" },
      { "name": "durationMinutes", "type": "Number", "min": 1 },
      { "name": "rating", "type": "Number", "min": 1, "max": 5 },
      { "name": "maturityRating", "type": "String", "enum": ["G", "PG", "PG-13", "R", "NC-17", "E", "T"] }
    ],
    "options": { "timestamps": true }
  },
  {
    "name": "Episode",
    "properties": [
      { "name": "seriesId", "type": "Reference", "reference": "Content", "required": true },
      { "name": "seasonNumber", "type": "Number", "required": true, "min": 1 },
      { "name": "episodeNumber", "type": "Number", "required": true, "min": 1 },
      { "name": "title", "type": "String", "required": true },
      { "name": "airDate", "type": "Date" }
    ],
    "options": { "timestamps": true }
  },
  {
    "name": "PlaybackHistory",
    "properties": [
      { "name": "accountId", "type": "Reference", "reference": "UserAccount", "required": true },
      { "name": "contentId", "type": "Reference", "reference": "Content", "required": true },
      { "name": "lastPlayedPositionSeconds", "type": "Number", "default": 0, "min": 0 },
      { "name": "isCompleted", "type": "Boolean", "default": false },
      { "name": "deviceType", "type": "String", "enum": ["mobile", "web", "tv", "console"] }
    ],
    "options": { "timestamps": true }
  },
  {
    "name": "Watchlist",
    "properties": [
      { "name": "accountId", "type": "Reference", "reference": "UserAccount", "required": true },
      { "name": "contentId", "type": "Reference", "reference": "Content", "required": true },
      { "name": "priority", "type": "Number", "default": 0, "min": 0 }
    ],
    "options": { "timestamps": true }
  }
]
}